import { render, staticRenderFns } from "./LogisticsList.vue?vue&type=template&id=1b06d636&scoped=true&"
import script from "./LogisticsList.vue?vue&type=script&lang=js&"
export * from "./LogisticsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06d636",
  null
  
)

export default component.exports